/**
 * Hamburger toggle for the navigation.
 */

const navigation = document.getElementById('site-navigation');
const toggleButton = document.getElementById('site-navigation-button');

const navigationActiveClassName = 'navigation--active';
const toggleButtonActiveClassName = 'hamburger--active';

const showNavigation = () => {
    navigation.classList.add(navigationActiveClassName);
    toggleButton.classList.add(toggleButtonActiveClassName);
    toggleButton.setAttribute('aria-expanded', 'true');
};

const hideNavigation = () => {
    navigation.classList.remove(navigationActiveClassName);
    toggleButton.classList.remove(toggleButtonActiveClassName);
    toggleButton.setAttribute('aria-expanded', 'false');
};

if (navigation && toggleButton) {
    toggleButton.addEventListener('click', e => {
        const isActive = toggleButton.getAttribute('aria-expanded') === 'true';
        isActive ? hideNavigation() : showNavigation();
    });

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
            hideNavigation();
        }
    });
}

/**
 * Opening and closing for menu flyouts.
 */

const menus = document.querySelectorAll('.menu');

const closeAllFlyouts = menuItemsWithFlyouts => {
    menuItemsWithFlyouts.forEach(el => el.classList.remove('menu__item--active'));
};

const toggleFlyout = (menuItem, menuItemsWithFlyouts) => {
    const isActive = menuItem.classList.contains('menu__item--active');

    // Allow only one open flyout in the desktop navigation
    const isMobileLayout = Boolean(toggleButton.offsetParent);
    if (!isMobileLayout) {
        closeAllFlyouts(menuItemsWithFlyouts);
    }

    if (isActive) {
        menuItem.classList.remove('menu__item--active');
    } else {
        menuItem.classList.add('menu__item--active');
    }
};

menus.forEach(menu => {
    const menuItemsWithFlyouts = Array.from(menu.querySelectorAll('.menu__item--has-descendants'));

    if (menu) {
        menuItemsWithFlyouts.forEach(item => {
            const node = item.querySelector('.menu__node');

            node.addEventListener('click', e => {
                e.preventDefault();
                toggleFlyout(item, menuItemsWithFlyouts);
            });

            node.addEventListener('keydown', e => {
                if (!['Enter', ' '].includes(e.key)) return;
                e.preventDefault();
                toggleFlyout(item, menuItemsWithFlyouts);
            });
        });

        navigation.addEventListener('keydown', e => {
            if (e.key !== 'Escape') return;
            closeAllFlyouts(menuItemsWithFlyouts);
        });

        document.addEventListener('click', e => {
            if (!menu || menu.contains(e.target)) return;
            closeAllFlyouts(menuItemsWithFlyouts);
        });
    }
});
